import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

import { DffCookieConsentService } from "@e-forsyning/web-components/shared/dff-cookie-consent";

@Injectable({ providedIn: "root" })
export class ServiceProFunctionalConsentService {
    constructor(private readonly cookieConsentService: DffCookieConsentService) {}

    /** Valgfri funktionel storage (værkvalg, oversigtskort) kræver statistics-samtykke. */
    public hasFunctionalConsent(): boolean {
        return this.cookieConsentService.getCookieConsent().consent.statistics;
    }

    public selectFunctionalConsent(): Observable<boolean> {
        return this.cookieConsentService.selectCookieConsent().pipe(
            map(({ consent }) => consent.statistics),
            distinctUntilChanged()
        );
    }
}
